import React, { useContext, useEffect, useMemo, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBackspace } from "@fortawesome/free-solid-svg-icons";

import SelectControl from '../SelecControl/SelectControl.jsx';

import { estructuraTarea } from '../../utils/estructuras.js';

import './ControlesSubtabla.css';
import FormControl from '../formControl/FormControl.js';
import controlContext from '../../context/controlesContext/controlContex.js';

const ControlesSubtabla = ({controles,  setState, tablaSeleccionada, tipo, completedTasks=0, componentePadre, handleChangeCheckTask=()=>console.log("Check"), checklistID}) =>{

    const [data,setData] = useState(''); //Data contiene la informacion de la tarea modificada.
    const [showAddTarea,setShowAddTarea] = useState(false); //Estado encargado de renderizar o no el FormTarea, independientemente de si se modifica o agrega una nueva.
    const [nuevoEditado, setNuevoEditado] = useState("Agregar"); //Setea el titulo mostrado luego en FormTarea, donde se indica si se esta agregando una tarea o modificandola.
    const [indexToUpdate,setIndexToUpdate] = useState(-1); //Index donde al clickear boton Editar Tarea se especifica el indice de la tarea a modificar en el procedimiento.
    
    const {controlList} = useContext(controlContext);

    const minimizar = () => {
        setShowAddTarea(false);
    }

    const options = useMemo(()=> (controlList && controlList.length > 0) ? controlList.map(c => ({label: c.name, value: c.codigo, id: c._id, descrp: c.descrp, name: c.name, showDescrp: c.showDescrp})) : [],[controlList]);

    const handleChangeControles = (componente = {},i,taskDescrp = undefined, prop = undefined) => {
        setState((prevState) => {
            let controles = prevState.controles.slice();
            if(taskDescrp != undefined && Object.keys(componente).length == 0 && prop != undefined){
                controles[i][prop] = taskDescrp;
                let newState = {...prevState,['controles']:controles};
                return newState; 
            }else if(taskDescrp != undefined && Object.keys(componente).length == 0){ 
                if(controles[i].value !== ''){ 
                    controles[i].taskDescrp = taskDescrp;
                }
                let newState = {...prevState,['controles']:controles};
                return newState; 
            }else{
                if(Object.keys(componente).length == 0){
                    controles.splice(i,1);
                }else if(controles[i].value !== ''){ 
                    controles[i] = componente;
                    controles[i].taskDescrp = "";
                }else{
                    controles[i] = componente;
                    controles[i].taskDescrp = "";
                    controles.push({...estructuraTarea});
                }
                let newState = {...prevState,['controles']:controles};
                return newState; 
            }   
        })
    }

    const handleDeleteTarea = (componente,index) => {
        setState((prevState) => {
            let controles = prevState.controles.slice();
            if(controles.length > 0 && index > -1 && componente.label !== ''){
                controles = prevState.controles.filter((componente,i) => i !== index);
            }
            let newState = {...prevState,['controles']:controles};
            return newState;
        });
    }

    const handleNoDisparaProc = (i, checked) => {
        setState((prevState) => {
            let controles = prevState.controles.slice();
            controles[i] = {...controles[i], noDisparaProc: checked};
            return {...prevState, controles};
        });
    }

    const cantidadTareas = (controles != undefined) ? controles.filter(t => t.label != '').length : 0;

    return <div className={`${(tablaSeleccionada != 'controles') && 'inactive'} tareasDiv`} id={`${tipo =='tareaOT' && completedTasks == cantidadTareas ? 'tareasCompletadas' : ''}`}>
    <label>Controles</label>
    <div className={`tareasXprocedimiento`}>
        <div className={`headerSubtabla ${(componentePadre != 'FormReq' ? 'twoColumns' : '')}`}>
            <label>Control</label>
            <label>Texto Adicional</label>
            {componentePadre == 'FormReq' && <label>Texto Adicional 2</label>}
            {componentePadre == 'FormChecklist' && <label>No dispara procedimiento</label>}
        </div>
        {(controles == undefined) ? <h5>Cargando controles...</h5> : 
        controles.length > 0 && controles.map((control,i) =><div className={`ctrlDiv ${componentePadre == 'FormReq' ? 'threeColumns' : ''}`} key={`${control.codigo}-${i}`}> 
            
            {componentePadre != 'FormReq' && <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteTarea(control,i)} />}

            <SelectControl placeholder={"Seleccione una tarea..."} modo={"Nuevo"} setShowAdd={setShowAddTarea} idSelect={"tarea"} handleChengeSelect={handleChangeControles} optionsSelect={options} valueSeleccionada={control} tipo={tipo}  selectSelect={handleChangeControles} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate}/>
            
            {(tipo == 'tareaOT' && componentePadre != 'FormReq') && <label className='customCheckbox'>
                <input disabled={control.label == ''} value={control.done} className='checkboxTask' type='checkbox' onChange={(e) => handleChangeCheckTask(e,i)}/>
                <span className={`${(control.done) ? 'checked' : ''}`}></span>
            </label>}

            <input className="inputDescrp" name="textAdic" disabled={tipo == 'controlOT'} value={control.textAdic ? control.textAdic : control.taskDescrp} onChange={(e) => handleChangeControles({},i,e.target.value)} placeholder="Ingrese una descripción adicional..."/>
            
            {componentePadre == 'FormReq' && <input className="inputDescrp" name="textAdic2" value={control.textAdic2} onChange={(e) => handleChangeControles({},i,e.target.value,'textAdic2')} placeholder="Ingrese un texto adicional 2..."/>}

            {componentePadre == 'FormChecklist' && <div className="ctrlNoDisparaProcDiv">
                <input type='checkbox' className='ctrlNoDisparaProc' checked={control.noDisparaProc || false} onChange={(e) => handleNoDisparaProc(i, e.target.checked)} disabled={control.label === ''}/>
            </div>}
        </div>)
        }
        {showAddTarea && <FormControl data={data} setData={setData} minimizar={minimizar} nuevoEditado={nuevoEditado} handleChangeControles={handleChangeControles} index={indexToUpdate} checklistID={checklistID}/> }
    </div>
    </div>

}

export default ControlesSubtabla;